// Vista del Docente — sus estudiantes asignados, con avatar, edad, curso y estado.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GraduationCap, Users, AlertCircle, CheckCircle2 } from "lucide-react";
import { Pagination } from "@/components/Pagination";

const PAGE_SIZE = 10;

export default function DocenteMisEstudiantes() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/users", { params: { role: "estudiante" } });
        setStudents(data);
      } finally { setLoading(false); }
    })();
  }, []);

  const paged = students.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="space-y-6" data-testid="docente-mis-estudiantes-page">
      <div>
        <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#2C49A0]">Administración</p>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#1F2547]">Mis estudiantes</h1>
        <p className="text-sm text-[#6E7591] mt-1">Los estudiantes asignados a tu acompañamiento y su perfil rápido.</p>
      </div>
      <div className="jasq-card overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b-2 border-[#E1E5F0] bg-[#F7F8FA]">
              {["Estudiante", "Edad", "Curso", "Diagnóstico"].map((h) => (
                <th key={h} className="text-left text-[11px] tracking-wider uppercase font-extrabold text-[#6E7591] px-5 py-3">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && (<tr><td colSpan={4} className="p-8 text-center text-sm text-[#6E7591]">Cargando…</td></tr>)}
            {!loading && students.length === 0 && (
              <tr><td colSpan={4} className="p-8 text-center text-sm text-[#6E7591]">
                <AlertCircle className="inline mr-2" size={14} /> No tienes estudiantes asignados todavía.
              </td></tr>
            )}
            {paged.map((s) => (
              <tr key={s.id} className="border-b border-[#E1E5F0] last:border-0 hover:bg-[#FAFBFE]" data-testid={`student-row-${s.id}`}>
                <td className="px-5 py-3">
                  <div className="flex items-center gap-3">
                    <img src={s.avatar} alt="" className="w-9 h-9 rounded-full border-2 border-[#E1E5F0] object-cover" />
                    <div>
                      <p className="text-sm font-extrabold text-[#1F2547]">{s.name}</p>
                      <p className="text-[11px] text-[#6E7591]">{s.email}</p>
                    </div>
                  </div>
                </td>
                <td className="px-5 py-3 text-sm text-[#4C5478]">{s.age || "—"} años</td>
                <td className="px-5 py-3 text-sm text-[#4C5478]">{s.grade || "—"}</td>
                <td className="px-5 py-3">
                  <span className="jasq-pill bg-[#F7F8FA] text-[#1F2547] text-xs">
                    {s.diagnostic_done ? <CheckCircle2 size={12} className="text-[#3FA84D]" /> : <AlertCircle size={12} className="text-[#A52258]" />}
                    {s.qualitative_status || "Pendiente"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination page={page} pageSize={PAGE_SIZE} total={students.length} onPageChange={setPage} testid="mis-estudiantes-pagination" />
      </div>
    </div>
  );
}
